import clsx from 'clsx'
import FieldDetail from 'components/FieldDetail'
import { useStore } from 'context/store'
import { Dialog } from 'primereact/dialog'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useIsMobile } from 'utils/hooks/useIsMobile'
import UserRegistrationHistory from './UserRegistrationHistory'

const RegisteredHistory = () => {
  const [showModalHistory, setShowModalHistory] = useState(false)
  const { t } = useTranslation()
  const isMobile = useIsMobile()
  const {
    eventRegistrationStore: { selectedItem },
  } = useStore()
  return (
    <>
      <Dialog
        onHide={() => {
          setShowModalHistory(false)
        }}
        header={t('Registed History')}
        visible={showModalHistory}
        className={clsx(
          isMobile &&
            'mobile-select-branch-dialog m-0 shadow-none border-noround'
        )}
        contentClassName={clsx(
          isMobile && 'p-0 h-full max-h-full flex flex-column overflow-hidden'
        )}
        style={
          isMobile
            ? {
                width: '100vw',
                maxWidth: '100vw',
                height: '100vh',
                maxHeight: '100vh',
              }
            : { width: '80vw', height: '70vh' }
        }
      >
        <UserRegistrationHistory userId={selectedItem.customer._id} />
      </Dialog>
      <FieldDetail
        label={t('Registed History')}
        hiddenWhenEmpty={false}
        value={
          <ul className="pl-4 my-0">
            <li>
              {t('Registed')}:{' '}
              {selectedItem.customer?.registeredHistory.registeredNumber}
            </li>
            <li>
              {t('Canceled')}:{' '}
              {selectedItem.customer?.registeredHistory.canceledNumber}
            </li>
            <li>
              {t('Not checked in')}:{' '}
              {selectedItem.customer?.noShowCountTotal ?? 0}
            </li>
          </ul>
        }
        btnExpand={
          <div
            className="text-blue-500 cursor-pointer font-normal"
            onClick={() => setShowModalHistory(true)}
          >
            ({t('View')})
          </div>
        }
      />
    </>
  )
}

export default RegisteredHistory
